import { tidyText } from '../../utils/tidyText';

function Answer({ answer, onClick }) {
  return (
    <button
      type="button"
      className="quiz-answer"
      onClick={() => onClick(answer)}
    >
      <span className="quiz-answer-radio" aria-hidden />
      <span className="quiz-answer-label">{tidyText(answer)}</span>
    </button>
  );
}

function AnswerCard({ answers, onClick }) {
  return (
    <div className="quiz-answers">
      {answers.map((answer) => (
        <Answer
          key={answer}
          answer={answer}
          onClick={onClick}
        />
      ))}
    </div>
  );
}

export default AnswerCard;
